import React from 'react';
import AdvantageCard from '../../common/AdvantageCard/AdvantageCard';
import ShadedImage from '../../../assets/icons/shadedemify.png';
import styles from './Advantage.module.scss';

const Advantage = () => {
  const cards = [
    {
      icon: '/assets/icons/mandate-icon.png',
      title: 'Advance E-Mandate Creation',
      description: 'Simple and fast mandate creation for secure collections.',
    },
    {
      icon: '/assets/icons/secure-transactions-icon.png',
      title: 'Secure Transactions',
      description: 'End-to-end encrypted payment processing.',
    },
    {
      icon: '/assets/icons/reconciliation-icon.png',
      title: '24/7 Automated Reconciliation',
      description: 'Real-time payment tracking with zero manual effort.',
    },
  ];

  return (
    <section className={styles.advantage}>
      <div className={styles.content}>
        <h2>
          The <span>EMIfy</span> Advantage
        </h2>
        <div className={styles.description}>
          Maximize efficiency with automation, enhanced security, and real-time insights.
        </div>
      </div>
      <div className={styles.shadedImage}> <img src={ShadedImage} alt='shadedimage'/></div>
      <div className={styles.cards}>
        {cards.map((card, idx) => (
          <AdvantageCard
            key={idx}
            icon={card.icon}
            title={card.title}
            description={card.description}
          />
        ))}
      </div>
    </section>
  );
};

export default Advantage;
